import * as pdfjs from "pdfjs-dist"

var usePdf = ({canvasRef, file, scale = 1.0, rotate = 0, page = 1, baseUrl}) => {
  pdfjs.GlobalWorkerOptions.workerSrc = baseUrl + 'miniapp/lib/widgets/pdfjs/pdf.worker.min.js'
  const [pdfDocument, setPdfDocument] = React.useState()
  const [pdfPage, setPdfPage] = React.useState()
  const renderTask = React.useRef([])
  const lastPageRequestedRenderRef = React.useRef([])
  const drawPDFRef = React.useRef(null)

  React.useEffect(() => {
    if (!file) return
    pdfjs.getDocument({url: file}).promise.then((loadedPdfDocument) => { setPdfDocument(loadedPdfDocument) }, () => { throw new Error('Loading PDF doument failed.')})
  }, [file])

  React.useEffect(() => {
    const drawPDF = (page2, i) => {
      const rotation = rotate === 0 ? page2.rotate : page2.rotate + rotate
      const viewport = page2.getViewport({scale, rotation})
      const canvasEl = canvasRef.current[i]
      if (!canvasEl) {
        return
      }
      const canvasContext = canvasEl.getContext("2d")
      if (!canvasContext) {
        return
      }
      // commented devicePixelRatio because on mobile not started in fit width
      canvasEl.height = viewport.height/* * window.devicePixelRatio*/
      canvasEl.width = viewport.width/* * window.devicePixelRatio*/
      //canvasContext.scale(window.devicePixelRatio, window.devicePixelRatio)
      if (renderTask.current[i]) {
        lastPageRequestedRenderRef.current[i] = page2
        renderTask.current[i].cancel()
        return
      }
      renderTask.current[i] = page2.render({canvasContext, viewport})
      return renderTask.current[i].promise.then(() => { renderTask.current[i] = null },
        (reason) => {
          renderTask.current[i] = null
          if (reason && reason.name === "RenderingCancelledException") {
            const lastPageRequestedRender = lastPageRequestedRenderRef.current[i] ?? page2
            lastPageRequestedRenderRef.current[i] = null
            drawPDFRef.current(lastPageRequestedRender, i)
          } else {
            throw new Error('Rendering PDF document failed.')
          }
        }
      )
    }
    drawPDFRef.current = drawPDF
    if (!pdfDocument || scale === null) return
    if (page == 'all') {
      for (let i=1; i<=pdfDocument.numPages; i++) {
        pdfDocument.getPage(i).then((loadedPdfPage) => {setPdfPage(loadedPdfPage); drawPDF(loadedPdfPage, i-1)}, (e) => {throw new Error('Rendering PDF document failed. ' + e)})
      }
    } else {
      pdfDocument.getPage(page).then((loadedPdfPage) => {setPdfPage(loadedPdfPage); drawPDF(loadedPdfPage, 0)}, (e) => {throw new Error('Rendering PDF document failed. ' + e)})
    }
  }, [canvasRef, page, pdfDocument, rotate, scale])

  return {pdfDocument, pdfPage}
}

export {usePdf}